// Get Zustand persist values from local storage. Zustand does not keep states synchronized with local storage,
// and for that reason we need to read the values from local storage to take care we have the latest values.

const storageName = "clausion-dr";

function isLocalStorageAvailable(): boolean {
  return localStorage.getItem(storageName) !== null;
}

export function getAutomaticCalculation(): boolean {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.automaticCalculation;
  }
  return false;
}

export function getServiceUrl(): string {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.serviceUrl;
  }
  return "";
}

export function getRefreshMode(): string {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.refreshMode;
  } else {
    return "Sheet";
  }
}

export function getIsRefreshInProgress(): boolean {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.isRefreshInProgress;
  } else {
    return false;
  }
}

export function getIsLoggingEnabled(): boolean {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.isLoggingEnabled;
  } else {
    return false;
  }
}

export function getDRErrorValue(): string {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.drErrorValue;
  } else {
    return "";
  }
}

export function getAccessToken(): string | null {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.auth?.accessToken ?? null;
  } else {
    return null;
  }
}

export function getCacheTtl(): number {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.cacheTtl ?? 5;
  } else {
    return 5;
  }
}

export function getForceRefreshTimestamp(): number {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(storageName)).state.forceRefreshTimestamp ?? 0;
  } else {
    return 0;
  }
}
